<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Expense information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap justify-end>
            <v-flex shrink>
              <v-chip v-if="fileSelected" :selected="fileSelected" @input="removeFile()" close dark color="primary">
                <v-avatar>
                  <v-icon>insert_drive_file</v-icon>
                </v-avatar>
                <a
                  v-if="expenseInfo.attachment !== null"
                  :href="`${baseUrls.images}/${expenseInfo.attachment}`"
                  target="_blank"
                  style="color: white; text-decoration: none"
                >
                  {{ $t('Click to View Attachment') }}
                </a>
                <span v-else>{{ fileName | truncate }}</span>
              </v-chip>
              <v-btn :disabled="fileSelected" @click="chooseFile" color="primary" class="white--text">
                <v-icon left dark>attach_file</v-icon>
                {{ $t('Attach file') }}
              </v-btn>
              <input
                type="file"
                name="file"
                ref="fileInput"
                style="visibility:hidden; width:0; position:absolute; top:-9999px"
                @input="onSelectFile"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-content-end>
            <v-flex xs6 sm6 class="pa-2">
              <v-text-field
                v-model="expenseInfo.amount"
                :label="`${$t('Amount')} (${systemCurrency}) *`"
                box
                hide-details
                background-color="white"
                :append-icon="expenseInfo.payment_type === 'Cash' ? 'fa-hand-holding-usd' : ''"
                @click:append="isMultiCurrency = !isMultiCurrency"
                :readonly="isMultiCurrency"
                :error="errors.has('Amount')"
                data-vv-name="Amount"
                v-validate="'required|decimal:3|min_value:0'"
              />
            </v-flex>

            <!--            <v-flex xs3 pa-2>-->
            <!--              <v-autocomplete-->
            <!--                :items="paymentTypes"-->
            <!--                v-model="expenseInfo.payment_type"-->
            <!--                :label="`${$t('Payment Type')}`"-->
            <!--                box-->
            <!--                hide-details-->
            <!--                :error="errors.has('payment_type')"-->
            <!--                background-color="white"-->
            <!--                name="payment_type"-->
            <!--                :menu-props="{ transition: 'slide-y-transition' }"-->
            <!--                ref="paymentType"-->
            <!--                @input="checkMultiCurrency()"-->
            <!--              />-->
            <!--            </v-flex>-->

            <v-flex xs6 sm6 class="pa-2">
              <v-menu v-model="paymentDateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="expenseInfo.payment_date"
                  :label="`${$t('Payment Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="payment_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('payment_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="paymentDateMenu = false" v-model="expenseInfo.payment_date" />
              </v-menu>
            </v-flex>

            <v-flex xs6 sm6 class="pa-2" v-if="isMultiCurrency">
              <v-text-field
                v-if="isMultiCurrency"
                v-model="expenseInfo.amount_main"
                :label="`${$t('Amount')} (${systemCurrency}) *`"
                box
                hide-details
                background-color="white"
                name="amount_main"
                :error="errors.has('amount_main')"
                v-validate="'required|decimal:3|min_value:0'"
                @input="amountCalculation()"
              />
            </v-flex>

            <v-flex xs6 sm6 pr-2 pl-2 pt-2 v-if="isMultiCurrency">
              <v-text-field
                v-if="isMultiCurrency"
                v-model="expenseInfo.amount_secondary"
                :label="`${$t('Amount')} (${systemCurrency === 'USD' ? $t('IQD') : $t('USD')}) *`"
                box
                :hint="`${$t('Dollar Rate')} : ${expenseInfo.dollar_rate}`"
                persistent-hint
                background-color="white"
                name="amount_secondary"
                :error="errors.has('amount_secondary')"
                v-validate="'required|decimal:3|min_value:0'"
                @input="amountCalculation()"
              />
            </v-flex>

            <v-flex pa-2>
              <v-autocomplete
                :items="expenseTypesList"
                v-model="expenseInfo.expense_type_id_fk"
                :label="`${$t('Expense Type')} *`"
                v-validate="'required'"
                box
                autofocus
                hide-details
                :error="errors.has('Expense Type')"
                background-color="white"
                data-vv-name="Expense Type"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs1 pt-2 v-if="hasPermissions(['expense_types_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-expense-type')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new expenses type') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex pa-2>
              <v-autocomplete
                :items="vendersList"
                v-model="expenseInfo.vender_id_fk"
                :label="`${$t('Supplier')}`"
                box
                hide-details
                :error="errors.has('Supplier')"
                background-color="white"
                data-vv-name="Supplier"
                :menu-props="{ transition: 'slide-y-transition' }"
                v-validate="'required_if:paymentType,On Account'"
              />
            </v-flex>

            <v-flex xs1 pt-2 v-if="hasPermissions(['vender_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-supplier')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new supplier') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-model="expenseInfo.voucher_number"
                :label="$t('Voucher Number')"
                box
                hide-details
                name="voucher_number"
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-model="expenseInfo.payment_recipient"
                :label="$t('Payment Recipient')"
                box
                name="payment_recipient"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs12 sm12 md12 class="pa-2">
              <v-textarea
                v-model="expenseInfo.note"
                :label="`${$t('Note')}`"
                name="note"
                hide-details
                box
                height="80"
                background-color="white"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dialogs: {
        addExpenseType: false,
        addSupplier: false
      },
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      paymentDateMenu: false,
      isMultiCurrency: false,
      attachment: null,
      fileSelected: false,
      fileName: '',
      fileData: null,
      fileInput: null,
      theFile: null
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      dollarRate: 'dollarRates/getLastDollarPrice',
      expenseInfo: 'expenses/getExpenseInfo',
      expenseTypesList: 'expenseTypes/getFullExpenseTypesList',
      paymentTypes: 'purchases/getPaymentTypes',
      vendersList: 'suppliers/getFullVendersList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.removeFile()
          this.addEscKeyListener()

          this.isMultiCurrency = this.expenseInfo.is_multi_currency === '1'
          if (this.expenseInfo.dollar_rate === undefined) {
            this.expenseInfo.dollar_rate = this.dollarRate
          }
          if (this.expenseInfo.attachment) {
            this.attachment = this.expenseInfo.attachment
            this.fileSelected = true
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateExpenseInfo: 'expenses/updateExpenseInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    checkMultiCurrency() {
      if (this.expenseInfo.payment_type === 'On Account') {
        this.isMultiCurrency = false
      }
    },

    chooseFile() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.fileInput = this.$refs.fileInput
      this.theFile = this.fileInput.files

      if (this.theFile && this.theFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.fileData = e.target.result
        }
        reader.readAsDataURL(this.theFile[0])
        this.$emit('input', this.theFile[0])
        this.fileName = this.theFile[0].name
        this.fileSelected = true
      }
    },

    removeFile() {
      this.fileData = null
      this.fileInput = null
      this.theFile = null
      this.$refs.fileInput.value = null
      this.attachment = null
      this.fileName = ''
      this.fileSelected = false
    },

    amountCalculation() {
      const exchangeSecondary =
        this.systemCurrency === 'USD'
          ? Number(this.expenseInfo.amount_secondary || 0) / this.expenseInfo.dollar_rate
          : Number(this.expenseInfo.amount_secondary || 0) * this.expenseInfo.dollar_rate
      this.expenseInfo.amount = (Number(this.expenseInfo.amount_main || 0) + exchangeSecondary).toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true
          let formData = new FormData(event.target)
          formData.append('is_multi_currency', this.isMultiCurrency ? '1' : '0')
          formData.append('dollar_rate', this.expenseInfo.dollar_rate)
          formData.append('payment_type', 'Cash')
          formData.append('expense_type_id_fk', this.expenseInfo.expense_type_id_fk || '')
          formData.append('vender_id_fk', this.expenseInfo.vender_id_fk || '')
          formData.append('amount', this.expenseInfo.amount)
          if (this.theFile === null && this.attachment === null) {
            formData.append('attachment', '')
          } else if (this.theFile !== null) {
            formData.append('attachment', this.theFile[0])
          }

          let payload = { id: this.expenseInfo.expense_id, formData }
          this.updateExpenseInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
